<template>
  <div>
    <list-breadcrumbs></list-breadcrumbs>
    <recursive-task style="margin-left: -11px" :tasks="list"></recursive-task>
    <undoer></undoer>
    <raw-displayer title="unflattenedMasterList" :value="list"></raw-displayer>
    <raw-displayer title="currentList" :value="currentList"></raw-displayer>
    <raw-displayer title="tasks" :value="tasks"></raw-displayer>
  </div>
</template>

<script>
import ListBreadcrumbs from "@/components/ListBreadcrumbs.vue";
import RecursiveTask from "@/components/RecursiveTask.vue";
import Undoer from "@/components/Undoer.vue";
import RawDisplayer from "@/components/microcomponents/RawDisplayer.vue";

export default {
  name: "ListView",
  components: {
    "list-breadcrumbs": ListBreadcrumbs,
    "recursive-task": RecursiveTask,
    undoer: Undoer,
    "raw-displayer": RawDisplayer
  },
  computed: {
    list: {
      get() {
        return this.$store.getters.getActiveMasterList;
      }
    },
    currentList: {
      get() {
        return this.$store.state.currentList;
      }
    },
    tasks: {
      get() {
        return this.$store.state.tasks;
      }
    }
  },
  beforeCreate() {
    this.$store.commit("switchToMasterList");
  }
};
</script>
